import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as DataAccessTogglesActions from './data-access-toggles.actions';
import * as DataAccessTogglesSelectors from './data-access-toggles.selectors';

import { FeatureFlagToggleList, FeatureFlagToggles } from '../../interface/feature-flags.interfaces';

@Injectable()
export class DataAccessTogglesFacade {
  selectors: { [key: string]: Observable<boolean | undefined> } = {};

  toggles$ = this.store.pipe(select(DataAccessTogglesSelectors.getToggles));

  constructor(private readonly store: Store) {}

  flag(toggle: FeatureFlagToggles) {
    if (!Object.keys(this.selectors).includes(toggle)) {
      this.selectors = {
        ...this.selectors,
        [toggle]: this.store.pipe(select(DataAccessTogglesSelectors.getToggle, { key: toggle })),
      };
    }

    return this.selectors[toggle];
  }

  update(params: FeatureFlagToggleList) {
    this.store.dispatch(DataAccessTogglesActions.updated(params));
  }
}
